export default "__VITE_ASSET__B$9zHdW5__"